import type { SiteId } from "~domain/sites/models/site-model.ts";

import { z } from "zod";

export const backofficeFindSiteResponseSchema = z.object({
  id: z.number().transform((s) => s as SiteId),
});

export type BackofficeFindSiteResponse = z.infer<typeof backofficeFindSiteResponseSchema>;
